import { Fragment } from "react";
import {
  faCheckCircle, faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

import useRefundToolFormGrid from "./UseRefundToolFormGrid";

import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import ActionIntraPageButton from "@usas/ui-web/components/buttons/ActionIntraPageButton";
import Checkbox from "@usas/ui-web/components/checkboxes/Checkbox";
import Icon from "@usas/ui-web/components/icons/Icon";

import { formatDate, formatDateTimeToTimeTwelveHourClock } from "@usas/ui-web/utils/DateFunctions";

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from './RefundToolFormGrid.module.css';

const ItemRefundStatus = ({ isValid, statusText }) => {
  return (
    isValid === true
      ? <span className={style.FormGridValidItem}><Icon iconObj={faCheckCircle} /> {statusText}</span>
      : <span className={style.FormGridInvalidItem}><Icon iconObj={faExclamationTriangle} /> {statusText}</span>
  );
};

const GridRow = ({ item, onUpdateIsSelected }) => (
  <tr className={item.isRefunded === false && item.canBeRefunded !== true ? style.FormGridDisabledRow : ''}>
    <td>{item.itemName}</td>
    <td>${item.amount}</td>
    <td>{item.isFromPriorSeason === true
      ? <ItemRefundStatus isValid={false} statusText={'Yes'} />
      : <ItemRefundStatus isValid={true} statusText={'No'} />}
    </td>
    <td>
      {item.isRefunded === true
        ? <b>REFUNDED</b>
        : item.canBeRefunded !== true
          ? <b>NON-REFUNDABLE</b>
          : (
            <Checkbox
              name={`isSelected`}
              checked={item.isSelected}
              onChange={() => onUpdateIsSelected(item.id)} />
          )
      }
    </td>
  </tr>
);

const RefundToolFormGrid = ({ transactionObj, onSubmitFormCallback }) => {
  const {
    canSubmit,
    formGridState,
    onUpdateAllGridItems,
    onUpdateIsSelected,
    onSubmitRefundClicked
  } = useRefundToolFormGrid(transactionObj, onSubmitFormCallback);

  return (
    <Fragment>
      <div className="row">
        <div className={[global.HeaderText, style.FormGridHeader, 'col-xs-12', 'usas-extra-top-margin'].join(' ')}>
          <div className="usas-extra-bottom-margin"><strong>Member Name:</strong> {transactionObj.firstName} {transactionObj.lastName}</div>
          <div className="usas-extra-bottom-margin"><strong>Member Id:</strong> {transactionObj.memberId}</div>
          <div className="usas-extra-bottom-margin"><strong>Transaction Date:</strong> {formatDate(transactionObj.transactionDatetime)} {formatDateTimeToTimeTwelveHourClock(transactionObj.transactionDatetime)} UTC</div>
          <div className="usas-extra-bottom-margin"><strong>Was Within Last 30 Days?:</strong>
            {transactionObj.isWithin30Days === true
              ? <ItemRefundStatus isValid={true} statusText={'Yes'} />
              : <ItemRefundStatus isValid={false} statusText={'No'} />
            }
          </div>
          <ActionIntraPageButton type="button" onClick={() => onUpdateAllGridItems(canSubmit === true ? false : true)}>{canSubmit === true ? 'Unselect All' : 'Select All'}</ActionIntraPageButton>
        </div>
      </div>
      <table className={[style.RefundToolTable, global.UsasTable].join(' ')}>
        <thead>
          <tr>
            <th>Item Name</th>
            <th>Amount</th>
            <th>Is From Prior Season?</th>
            <th>Selected?</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(formGridState) && formGridState.length > 0
            ? formGridState.map((item, i) =>
              <GridRow key={i} item={item} onUpdateIsSelected={onUpdateIsSelected} />)
            : <tr><td colSpan="4">No Transaction Items</td></tr>
          }
        </tbody>
      </table>
      <div className="row usas-extra-top-margin">
        <div className={[style.FormGridFooter, 'col-xs-12', 'usas-extra-top-margin', 'usas-extra-bottom-margin'].join(' ')}>
          <PrimaryButton type="button" isDisabled={canSubmit !== true} onClick={(e) => onSubmitRefundClicked(e)}>Refund Selected</PrimaryButton>
        </div>
      </div>
    </Fragment>
  );
};

export default RefundToolFormGrid;